import { ApiKeyModel } from "./ApiKey.model";

export class ApiKey extends ApiKeyModel {
    // Add custom methods here
}
